import {Text, useBreakpointDown} from '@travel-frontend/core';
import {IconHelpOutline} from '@travel-frontend/icons';
import {Link} from '@travel-frontend/ui-components';

import {Container} from '@/modules/hotels/components/SeaSpotlight/components/SpotlightPromoBadge/components/Container';
import {IconWrapper} from '@/modules/hotels/components/SeaSpotlight/components/SpotlightPromoBadge/components/IconWrapper';
import {TouchContainer} from '@/modules/hotels/components/SeaSpotlight/components/SpotlightPromoBadge/components/TouchContainer';
import {Wrapper} from '@/modules/hotels/components/SeaSpotlight/components/SpotlightPromoBadge/components/Wrapper';

type Props = {
  badgeColor: string;
  textColor: string;
  linkUrl?: string;
  caption: string;
};

export const SpotlightPromoBadge: React.FunctionComponent<Props> = ({
  linkUrl,
  textColor,
  badgeColor,
  caption,
}) => {
  const smDown = useBreakpointDown('sm');

  const labelMapping = smDown ? 'labelSmallBold' : 'labelMediumBold';
  return (
    <Container
      badgeColor={badgeColor}
      textColor={textColor}
      justifyContent="center"
      alignItems="center"
      flexWrap="nowrap"
    >
      <Wrapper>
        <Link href={linkUrl} target="_blank" rel="noreferrer">
          <Text preset={labelMapping}>{caption}</Text>
        </Link>
        <IconWrapper>
          <IconHelpOutline fontSize="16px" />
          <TouchContainer />
        </IconWrapper>
      </Wrapper>
    </Container>
  );
};
